const getters = {
  premission: state => state.userLimit,
  menuList: state => state.menuList,
  height: state => state.height
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js